// Screen: Riunione terminata.

import { icon } from './icons.js';
import type { EndSummary } from './room.js';

export interface EndProps {
  summary: EndSummary;
  roomLabel: string;
}
interface Callbacks { onNew: () => void; }

export async function mountEndCall(root: HTMLElement, props: EndProps, cb: Callbacks): Promise<void> {
  const dur = Math.max(1000, props.summary.endedAt - props.summary.startedAt);
  root.innerHTML = `
    <div class="end-screen">
      <div class="end-card">
        <div class="waiting-badge" style="background: linear-gradient(135deg, var(--ala-navy-2), var(--ala-navy)); color: var(--ala-gold);">${icon('check', 'icon icon-lg')}</div>
        <h1>Riunione terminata</h1>
        <p>${escape(props.summary.roomLabel)}</p>
        <div class="end-summary">
          <div class="stat"><strong>${formatDuration(dur)}</strong><small>Durata</small></div>
          <div class="stat"><strong>${props.summary.peakPeerCount}</strong><small>Partecipanti</small></div>
          <div class="stat"><strong>${escape(props.summary.myName)}</strong><small>Tu come</small></div>
        </div>
        <div class="end-actions">
          <button class="btn-gold" id="new-meeting" type="button">${icon('refresh', 'icon icon-sm')} Nuova riunione</button>
          <button class="btn-ghost-dark" id="back-home" type="button">${icon('chevron-left', 'icon icon-sm')} Torna alla home</button>
        </div>
        <p style="margin-top: 24px; color: var(--rm-text-dim); font-size: 0.82rem;">
          Eventuali registrazioni sono disponibili nell'archivio del portale interno.
        </p>
      </div>
    </div>
  `;
  function leave() {
    location.hash = '';
    cb.onNew();
  }
  const newBtn = root.querySelector<HTMLButtonElement>('#new-meeting')!;
  const backBtn = root.querySelector<HTMLButtonElement>('#back-home')!;
  // Sia click che touchend per massimizzare compatibilità iOS Safari
  for (const ev of ['click', 'touchend']) {
    newBtn.addEventListener(ev, (e) => { e.preventDefault(); leave(); }, { passive: false });
    backBtn.addEventListener(ev, (e) => { e.preventDefault(); leave(); }, { passive: false });
  }
}

function formatDuration(ms: number): string {
  const s = Math.floor(ms / 1000); const h = Math.floor(s / 3600); const m = Math.floor((s % 3600) / 60); const sec = s % 60;
  if (h > 0) return `${h}h ${pad(m)}m`;
  return `${pad(m)}m ${pad(sec)}s`;
}
function pad(n: number): string { return String(n).padStart(2, '0'); }
function escape(s: string): string {
  return s.replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]!));
}
